/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAthletesByClub = /* GraphQL */ `
  query GetAthletesByClub($clubID: ID!) {
    getAthletesByClub(clubID: $clubID) {
      items {
        id
        clubID
        schoolID
        first_name
        last_name
        email
        middle_name
        address
        parish
        dob
        nrid
        gender
        country
        nationality
        home
        mobile
        medical
        medical_treatment1
        medical_treatment2
        medical_treatment3
        medical_treatment4
        medical_treatment5
        medications1
        medications2
        medications3
        medications4
        medications5
        supplements1
        supplements2
        supplements3
        supplements4
        supplements5
        alt_email
        photo_url
        waiver_url
        shirt_size
        pants_size
        shoe_size
        sig_waiver
        sig_antidope
        sig_authorize
        club_verified
        aab_verified
        fees_paid
        createdAt
        updatedAt
        club {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
        school {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getCoachesByClub = /* GraphQL */ `
  query GetCoachesByClub($clubID: ID!) {
    getCoachesByClub(clubID: $clubID) {
      items {
        id
        clubID
        first_name
        last_name
        userId
        email
        middle_name
        address
        parish
        home
        mobile
        aab_verified
        fees_paid
        createdAt
        updatedAt
        club {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
        owner
      }
      nextToken
    }
  }
`;
export const getAthlete = /* GraphQL */ `
  query GetAthlete($id: ID!) {
    getAthlete(id: $id) {
      id
      clubID
      schoolID
      first_name
      last_name
      email
      middle_name
      address
      parish
      dob
      nrid
      gender
      country
      nationality
      home
      mobile
      medical
      medical_treatment1
      medical_treatment2
      medical_treatment3
      medical_treatment4
      medical_treatment5
      medications1
      medications2
      medications3
      medications4
      medications5
      supplements1
      supplements2
      supplements3
      supplements4
      supplements5
      alt_email
      photo_url
      waiver_url
      shirt_size
      pants_size
      shoe_size
      sig_waiver
      sig_antidope
      sig_authorize
      club_verified
      aab_verified
      fees_paid
      createdAt
      updatedAt
      club {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
      school {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
    }
  }
`;
export const listAthletes = /* GraphQL */ `
  query ListAthletes(
    $filter: ModelAthleteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAthletes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clubID
        schoolID
        first_name
        last_name
        email
        middle_name
        address
        parish
        dob
        nrid
        gender
        country
        nationality
        home
        mobile
        medical
        medical_treatment1
        medical_treatment2
        medical_treatment3
        medical_treatment4
        medical_treatment5
        medications1
        medications2
        medications3
        medications4
        medications5
        supplements1
        supplements2
        supplements3
        supplements4
        supplements5
        alt_email
        photo_url
        waiver_url
        shirt_size
        pants_size
        shoe_size
        sig_waiver
        sig_antidope
        sig_authorize
        club_verified
        aab_verified
        fees_paid
        createdAt
        updatedAt
        club {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
        school {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const athletesBySchool = /* GraphQL */ `
  query AthletesBySchool(
    $schoolID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelAthleteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    athletesBySchool(
      schoolID: $schoolID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clubID
        schoolID
        first_name
        last_name
        email
        middle_name
        address
        parish
        dob
        nrid
        gender
        country
        nationality
        home
        mobile
        medical
        medical_treatment1
        medical_treatment2
        medical_treatment3
        medical_treatment4
        medical_treatment5
        medications1
        medications2
        medications3
        medications4
        medications5
        supplements1
        supplements2
        supplements3
        supplements4
        supplements5
        alt_email
        photo_url
        waiver_url
        shirt_size
        pants_size
        shoe_size
        sig_waiver
        sig_antidope
        sig_authorize
        club_verified
        aab_verified
        fees_paid
        createdAt
        updatedAt
        club {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
        school {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listClubs = /* GraphQL */ `
  query ListClubs(
    $filter: ModelClubFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClubs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          items {
            id
          }
        }
        school_athletes {
          items {
            id
          }
        }
        coaches {
          items {
            id
          }
        }
      }
      nextToken
    }
  }
`;
export const getClub = /* GraphQL */ `
  query GetClub($id: ID!) {
    getClub(id: $id) {
      id
      name
      aab_verified
      organization_type
      createdAt
      updatedAt
      athletes {
        items {
          id
          clubID
          schoolID
          first_name
          last_name
          email
          middle_name
          address
          parish
          dob
          nrid
          gender
          country
          nationality
          home
          mobile
          medical
          medical_treatment1
          medical_treatment2
          medical_treatment3
          medical_treatment4
          medical_treatment5
          medications1
          medications2
          medications3
          medications4
          medications5
          supplements1
          supplements2
          supplements3
          supplements4
          supplements5
          alt_email
          photo_url
          waiver_url
          shirt_size
          pants_size
          shoe_size
          sig_waiver
          sig_antidope
          sig_authorize
          club_verified
          aab_verified
          fees_paid
          createdAt
          updatedAt
        }
        nextToken
      }
      school_athletes {
        items {
          id
          clubID
          schoolID
          first_name
          last_name
          email
          middle_name
          address
          parish
          dob
          nrid
          gender
          country
          nationality
          home
          mobile
          medical
          medical_treatment1
          medical_treatment2
          medical_treatment3
          medical_treatment4
          medical_treatment5
          medications1
          medications2
          medications3
          medications4
          medications5
          supplements1
          supplements2
          supplements3
          supplements4
          supplements5
          alt_email
          photo_url
          waiver_url
          shirt_size
          pants_size
          shoe_size
          sig_waiver
          sig_antidope
          sig_authorize
          club_verified
          aab_verified
          fees_paid
          createdAt
          updatedAt
        }
        nextToken
      }
      coaches {
        items {
          id
          clubID
          first_name
          last_name
          userId
          email
          middle_name
          address
          parish
          home
          mobile
          aab_verified
          fees_paid
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const getCoach = /* GraphQL */ `
  query GetCoach($id: ID!) {
    getCoach(id: $id) {
      id
      clubID
      first_name
      last_name
      userId
      email
      middle_name
      address
      parish
      home
      mobile
      aab_verified
      fees_paid
      createdAt
      updatedAt
      club {
        id
        name
        aab_verified
        organization_type
        createdAt
        updatedAt
        athletes {
          nextToken
        }
        school_athletes {
          nextToken
        }
        coaches {
          nextToken
        }
      }
      owner
    }
  }
`;
export const listCoachs = /* GraphQL */ `
  query ListCoachs(
    $filter: ModelCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoachs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clubID
        first_name
        last_name
        userId
        email
        middle_name
        address
        parish
        home
        mobile
        aab_verified
        fees_paid
        createdAt
        updatedAt
        club {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
        owner
      }
      nextToken
    }
  }
`;
export const coachByEmail = /* GraphQL */ `
  query CoachByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelCoachFilterInput
    $limit: Int
    $nextToken: String
  ) {
    coachByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clubID
        first_name
        last_name
        userId
        email
        middle_name
        address
        parish
        home
        mobile
        aab_verified
        fees_paid
        createdAt
        updatedAt
        club {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
        owner
      }
      nextToken
    }
  }
`;
export const athleteByEmail = /* GraphQL */ `
  query AthleteByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelAthleteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    athleteByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clubID
        schoolID
        first_name
        last_name
        email
        middle_name
        address
        parish
        dob
        nrid
        gender
        country
        nationality
        home
        mobile
        medical
        medical_treatment1
        medical_treatment2
        medical_treatment3
        medical_treatment4
        medical_treatment5
        medications1
        medications2
        medications3
        medications4
        medications5
        supplements1
        supplements2
        supplements3
        supplements4
        supplements5
        alt_email
        photo_url
        waiver_url
        shirt_size
        pants_size
        shoe_size
        sig_waiver
        sig_antidope
        sig_authorize
        club_verified
        aab_verified
        fees_paid
        createdAt
        updatedAt
        club {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
        school {
          id
          name
          aab_verified
          organization_type
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;